export default function initRevealContactLink() {
  Alpine.data('revealContactLink', () => ({
    visible: false,
    url: '#',
    label: '',
    obfuscatedUrl: '',
    obfuscatedLabel: '',

    init() {
      const host = this.$el;
      if (!(host instanceof HTMLElement)) {
        return;
      }

      this.obfuscatedUrl = host.dataset.obfuscatedUrl ?? '';
      this.obfuscatedLabel = host.dataset.obfuscatedLabel ?? '';
    },

    decodeObfuscated(value: string): string {
      return value.split('').reverse().join('');
    },

    reveal() {
      if (this.url === '#' && this.obfuscatedUrl !== '') {
        this.url = this.decodeObfuscated(this.obfuscatedUrl);
      }

      if (this.label === '' && this.obfuscatedLabel !== '') {
        this.label = this.decodeObfuscated(this.obfuscatedLabel);
      }

      this.visible = true;

      this.$nextTick(() => {
        const revealedLink = this.$refs.revealedLink;
        if (revealedLink instanceof HTMLAnchorElement) {
          revealedLink.focus();
        }
      });
    },
  }))
}

